<template>
  <div v-if="blockTables.length" class="d-grid gap-4 mt-4">
    <BaseAccordion
      v-for="(block, blockIndex) in blockTables"
      :key="'block_table_' + blockIndex"
      type="project"
      :text="block.name"
    >
      <BaseTableView
        v-if="block.mainRows.length"
        :head="tableHead"
        :class="$vuetify.breakpoint.xlOnly ? 'employee' : ''"
      >
        <tr v-for="(item, key) in block.mainRows" :key="'block_' + blockIndex + '_row_' + key">
          <td>{{ item.work_type.name }}</td>
          <td>{{ item.date ? $formatDate(item.date) : '—' }}</td>
          <td>
            {{
              item.work_type.is_hourly === 0
                ? $roundNumberToTenths(item.value) + ' ' + item.work_type.measure
                : $formatTime($roundNumberToTenths(item.value))
            }}
          </td>
        </tr>
      </BaseTableView>

      <div v-if="block.extraRows.length" class="extra-table-title">
        Extra work
      </div>
      <BaseTableView
        v-if="block.extraRows.length"
        :head="tableHead"
        :class="$vuetify.breakpoint.xlOnly ? 'employee' : ''"
      >
        <tr
          v-for="(item, key) in block.extraRows"
          :key="'block_' + blockIndex + '_extra_row_' + key"
          class="extra-row"
        >
          <td>{{ item.work_type.name }}</td>
          <td>{{ item.date ? $formatDate(item.date) : '—' }}</td>
          <td>{{ $formatTime($roundNumberToTenths(item.value)) }}</td>
        </tr>
      </BaseTableView>
    </BaseAccordion>
  </div>
</template>

<script>
export default {
  name: 'TimeControlShowTableBlock',
  props: ['periods', 'extra'],
  computed: {
    tableHead() {
      return [
        { text: this.localStorage.translations.pages.statistic_project.tables['vid-rabot'] },
        { text: this.localStorage.translations.pages.common.text['date'] || 'Date' },
        { text: this.localStorage.translations.pages.statistic_project.tables['fakt'] },
      ]
    },
    blockTables() {
      let grouped = {}

      const pushGroupedRow = ({ blockName, row }) => {
        if (!blockName) return

        if (!grouped[blockName]) {
          grouped[blockName] = {
            name: blockName,
            mainRows: [],
            extraRows: [],
          }
        }

        grouped[blockName][row.is_extra ? 'extraRows' : 'mainRows'].push(row)
      }

      for (let key in this.periods) {
        const period = this.periods[key]
        if (!period || !period.employees) continue

        for (let employeeKey in period.employees) {
          const employee = period.employees[employeeKey]
          const selectedBlocks = Array.isArray(employee.selected_block) ? employee.selected_block : []

          for (let selectedBlock of selectedBlocks) {
            if (!selectedBlock || !selectedBlock.block) continue
            pushGroupedRow({
              blockName: selectedBlock.block,
              row: {
                work_type: period.work_type,
                date: selectedBlock.date,
                value: selectedBlock.value,
                is_extra: false,
              },
            })
          }
        }
      }

      const projectExtra = Array.isArray(this.extra) ? this.extra : []
      for (let extraItem of projectExtra) {
        const selectedBlocks = Array.isArray(extraItem.selected_block) ? extraItem.selected_block : []

        for (let selectedBlock of selectedBlocks) {
          if (!selectedBlock || !selectedBlock.block) continue
          pushGroupedRow({
            blockName: selectedBlock.block,
            row: {
              work_type: {
                name: extraItem.name || 'Extra work',
                is_hourly: 1,
                measure: '',
              },
              date: selectedBlock.date,
              value: selectedBlock.value,
              is_extra: true,
            },
          })
        }
      }

      const result = Object.values(grouped)
      result.sort((a, b) => {
        if (a.name === b.name) return 0
        return a.name > b.name ? 1 : -1
      })

      for (let block of result) {
        block.mainRows.sort((a, b) => {
          if (a.date === b.date) return 0
          return a.date > b.date ? 1 : -1
        })
        block.extraRows.sort((a, b) => {
          if (a.date === b.date) return 0
          return a.date > b.date ? 1 : -1
        })
      }

      return result
    },
  },
}
</script>

<style lang="scss" scoped>
:deep().base-accordion {
  .base-accordion__head {
    background: #5e5e5e !important;
  }
}

.employee {
  :deep() td {
    &:nth-child(1) {
      width: 300px !important;
    }
    &:nth-child(2) {
      width: 150px !important;
    }
    &:nth-child(3) {
      width: 100px !important;
    }
  }
}

.extra-table-title {
  margin-top: 12px;
  margin-bottom: 8px;
  font-weight: 600;
  color: #5e6a73;
}

.extra-row {
  background: #fafafa !important;
}
</style>
